<template>
    <div class="side">
        <van-swipe ref="sliderRef" :autoplay="3000" indicator-color="#ff7a45" class="bannerImgBox">
            <van-swipe-item v-for="(item, index) in bannerList" :key="index" v-track:click :track-params="JSON.stringify({event: 100, bannerNumber: index + 1, bannerName: item.name})">
                <span @click="onLink(item.link)"><img :src="item.pictureUrl + '?x-oss-process=image/resize,h_308/format,jpg'" class="bannerImg" /></span>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
export default {
    props: {
        bannerList: {
            type: Array,
            default: () => {
                return []
            }
        },
        showBanner: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        showBanner () {
            this.$refs.sliderRef.onResize()
        }
    },
    methods: {
        onLink (link) {
            this.$emit('bannerClick', link)
        }
    }
}
</script>

<style lang="scss" scoped>
.side {
    height: 280px;
    font-size: 0;
    padding: 0 24px;
    margin-bottom: 24px;
    background-color: #fff;
}
.bannerImgBox {
    border-radius: 16px;
}
.bannerImg {
    display: inline-block;
    width: 100%;
    height: 280px;
    margin: 0 auto;
    background: #f2f3f5;
}
/deep/ .van-swipe__indicator {
    background: #fff;
    opacity: 1;
}
/deep/ .van-swipe__indicator:not(:last-child) {
    margin-right: 16px;
}
</style>